import {AsyncPage, Empty} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import {createAction} from 'Shared/utilities/actionCreator';
import {Bulletin} from '../models/Bulletin';
import {FilterOptionUnion, FilterOptionValue} from "Core/models/FilterOption";
import {DateRange} from "Core/models/DateRange";
import {Sort} from "Shared/components/PagedView/Table/Sort";
import * as O from "fp-ts/lib/Option";
import {BulletinDto} from "Documents/api/api";

export type FilterEnum = {
    name: string;
    value: string;
};

export enum BulletinsActionType {
    GET_BULLETINS = 'bulletins/GET_BULLETINS',
    CHANGE_BULLETINS = 'bulletins/CHANGE_BULLETINS',
    CHANGE_BULLETINS_FILTERS = 'bulletins/CHANGE_BULLETINS_FILTER',
    CHANGE_SORT = 'bulletins/CHANGE_SORT',
    CLEAR_SORT = 'bulletins/CLEAR_SORT',
    CLEAR_BULLETINS = 'bulletins/CLEAR_BULLETINS',
}

export const EmptyBulletinFilter: BulletinFilters = {
    created: {
        endDate: '',
        startDate: '',
    },
    bulletinType: FilterOptionValue.EmptyOption(),
    bulletinSubject: '',
    pageNumber: '1',
    pageSize: '25',
    emailed: {
        endDate: '',
        startDate: '',
    },
    channels: FilterOptionValue.EmptyOption(),
};

export type BulletinFilters = {
    created: DateRange;
    bulletinType: FilterOptionUnion;
    bulletinSubject: string;
    pageNumber: string;
    pageSize: string;
    emailed: DateRange;
    channels: FilterOptionUnion;
};


export const clearBulletins = (filters: BulletinFilters) => createAction(BulletinsActionType.CLEAR_BULLETINS, {filters});

export const getBulletins = (
    page?: Page<BulletinDto>,
    filter?: BulletinFilters,
    sort?: Sort,
    isNewYork?: boolean
) =>
    createAction(BulletinsActionType.GET_BULLETINS, {
        pageOption: page,
        filter,
        sort,
        isNewYork,
    });

export const changeBulletins = (bulletins: AsyncPage<Page<Bulletin>>) => createAction(BulletinsActionType.CHANGE_BULLETINS, bulletins);
export const changeBulletinsFilters = (filters: BulletinFilters) =>
    createAction(BulletinsActionType.CHANGE_BULLETINS_FILTERS, {filters});
export const changeSort = (sort?: Sort) => createAction(BulletinsActionType.CHANGE_SORT, {sort});
export const clearSort = () => createAction(BulletinsActionType.CLEAR_SORT);

type BulletinState = {
    bulletins: AsyncPage<Page<Bulletin>>;
    filters: BulletinFilters;
    sort: O.Option<Sort>;
};

export const DEFAULT_STATE: BulletinState = {
    bulletins: new Empty(),
    filters: EmptyBulletinFilter,
    sort: O.none,
};


type BulletinAction =
    | ReturnType<typeof clearSort>
    | ReturnType<typeof clearBulletins>
    | ReturnType<typeof changeSort>
    | ReturnType<typeof getBulletins>
    | ReturnType<typeof changeBulletins>
    | ReturnType<typeof changeBulletinsFilters>;


export default (state: BulletinState , action: BulletinAction): BulletinState => {
    const currentState = state || DEFAULT_STATE;
    switch (action.type) {
        case BulletinsActionType.CHANGE_BULLETINS:
            return {
                ...currentState,
                bulletins: action.payload,
            };
        case BulletinsActionType.CHANGE_BULLETINS_FILTERS:
            action.payload.filters.pageNumber = "1"
            return {
                ...currentState,
                filters: action.payload.filters,
            };
        case BulletinsActionType.CLEAR_SORT:
            state.filters.pageNumber = "1";
            return {
                ...currentState,
                sort: DEFAULT_STATE.sort,
            };
        case BulletinsActionType.CHANGE_SORT:
            state.filters.pageNumber = "1";
            return {
                ...currentState,
                sort: O.fromNullable(action.payload.sort),
            };
        case BulletinsActionType.CLEAR_BULLETINS:
            state.filters = EmptyBulletinFilter;
            return {
                ...currentState,
                filters: action.payload.filters,
            };
        default:
            return currentState;
    }
};
